import { useIntl } from 'react-intl';

import { AnonymousPasskeyActions } from './AnonymousPasskeyActions.tsx';
import { PageHeading } from './PageHeading.tsx';
import { Card, CardContent } from './ui/card.tsx';

export function AnonymousAuthGate({
  errorMessage,
  isActing,
  onSignIn,
  onSignUp,
  showActions,
  token,
}: {
  errorMessage: string | null;
  isActing: boolean;
  onSignIn: () => void;
  onSignUp: () => void;
  showActions: boolean;
  token: string | null;
}) {
  const intl = useIntl();
  return (
    <Card className="mt-8 border-border bg-card text-card-foreground shadow-[0_8px_18px_rgb(23_22_20_/_0.06)] [--card-spacing:1.25rem]">
      <CardContent className="grid gap-4">
        <div>
          <PageHeading className="text-base leading-relaxed font-bold tracking-normal">
            {intl.formatMessage({
              id:
                token && isActing
                  ? 'web.auth.telegramWaiting'
                  : 'web.auth.signInPrompt',
            })}
          </PageHeading>
          <p className="mt-1 leading-relaxed text-muted-foreground">
            {intl.formatMessage({ id: 'web.auth.signInDescription' })}
          </p>
        </div>
        {showActions ? (
          <AnonymousPasskeyActions
            isActing={isActing}
            onSignIn={onSignIn}
            onSignUp={onSignUp}
          />
        ) : null}
        {errorMessage ? (
          <p className="text-destructive">{errorMessage}</p>
        ) : null}
      </CardContent>
    </Card>
  );
}
